import {
  Property,
  PropertyDocuments,
} from '../../../../types/Property/Property'
import { useEffect, useState } from 'react'
import propertyService from '../../../../services/property.service'
import { HeroIcons } from '../../../../lib/utils/heroIcons'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import useLocale from '../../../../hooks/useLocale'

type DocumentSectionProps = {
  property: Property
}

export default function DocumentSection({ property }: DocumentSectionProps) {
  const { t } = useTranslation('originals/property')
  const { locale } = useLocale()

  const [propertyDocuments, setPropertyDocuments] = useState<
    PropertyDocuments[]
  >([])

  const fetchPropertyDocuments = async () => {
    const documentsPaginated = await propertyService.getPropertyDocuments(
      property.id,
      locale,
    )
    setPropertyDocuments(documentsPaginated.propertyDocuments)
  }

  useEffect(() => {
    fetchPropertyDocuments()
  }, [locale])

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {propertyDocuments.length ? (
        propertyDocuments.map((document) => (
          <div
            key={document.id}
            className="relative flex items-center space-x-3 rounded-lg border border-neutralBlack/40 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-brandLightBlue focus-within:ring-offset-2 hover:border-neutralBlack/20"
          >
            <div className="flex-shrink-0">
              <HeroIcons.DocumentIcon className="h-10 w-10 text-neutralBlack/90" />
            </div>
            <div className="min-w-0 flex-1">
              <Link
                target="_blank"
                href={document.url}
                className="focus:outline-none"
              >
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-sm font-medium text-neutralBlack">
                  {document.name}
                </p>
                <p className="truncate text-sm text-neutralBlack/50">
                  {t('documentsSection.clickToDownload')}
                </p>
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div className="font-bold text-neutralBlack">
          {t('documentsSection.noDocuments')}
        </div>
      )}
    </div>
  )
}
